import { Type } from 'class-transformer';
import {
  IsNotEmpty,
  IsArray,
  IsDateString,
  IsString,
  IsOptional,
  IsIn,
  ValidateNested,
} from 'class-validator';

import { CreateVacationUnitDto } from './create-vacation-unit.dto';

const NOT_EMPTY_OPTIONS = {
  message: 'Обязательное поле',
  groups: ['form'],
};

export class CreateVacationMainDto {
  @IsArray()
  @Type(() => String)
  @IsOptional()
  companyIds: string[];

  @IsDateString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  activeTo: string;

  @IsString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  addPreviousVacation: string;

  @IsIn(['units', 'company', 'custom_type'])
  @IsString()
  @IsNotEmpty(NOT_EMPTY_OPTIONS)
  type: 'units' | 'company' | 'custom_type';

  @IsString()
  @IsOptional()
  customType?: string;

  @IsIn(['legal', 'operational'])
  @IsString()
  @IsOptional()
  unit_type?: 'legal' | 'operational';

  @ValidateNested({ each: true })
  @Type(() => CreateVacationUnitDto)
  @IsArray()
  @IsOptional()
  unit_items?: CreateVacationUnitDto[];
}
